import FreelancerLayout from "../../layouts/FreelancerLayout";
import { getProfile, pipViewDate2, setProfile } from "../../utils/pip";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { findAJobPaths } from "../../routes/find-a-job";
import { useDispatch, useSelector } from "react-redux";
import { fetchfreelancerProfile } from "../../redux/features/find-a-job/actions/authAction";
import TagInput from "../../components/form/TagInput";
import Loader from "../../components/loader";
import ReadMoreText from "../../components/ReadMoreText/ReadMoreText";

const Profile = () => {
  const dispatch = useDispatch();
  const { subLoading, freelancerProfileData } = useSelector((state) => state.freelancer.auth);
  const hasServerProfile =
    freelancerProfileData && Object.keys(freelancerProfileData).length > 0;
  const profileData = hasServerProfile
    ? freelancerProfileData
    : getProfile("freelancer");
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const existing = getProfile("freelancer") || {};
        const merged = {
          ...data,
          full_name:
            data.full_name ||
            existing.full_name ||
            `${data.first_name || ""} ${data.last_name || ""}`.trim(),
          first_name: data.first_name || existing.first_name || data.full_name || "",
          last_name: data.last_name || existing.last_name || "",
        };
        setProfile("freelancer", merged);
      }
    });
  }, [dispatch]);

  const openTalent = profileData?.open_talent || {};
  const fullName =
    profileData?.full_name ||
    `${profileData?.first_name || ""} ${profileData?.last_name || ""}`.trim();
  const locationText =
    openTalent?.location ||
    [openTalent?.city, openTalent?.country].filter(Boolean).join(", ");

  const parseMaybeArray = (value, fallback = []) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallback;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return [trimmed];
      }
    }
    return fallback;
  };

  const experiences = parseMaybeArray(
    openTalent?.experiences ?? profileData?.experiences,
    []
  );
  const portfolioLinks = parseMaybeArray(openTalent?.portfolio_links, []);
  const workSamples = parseMaybeArray(openTalent?.work_samples, []);
  const workSampleProjects = Array.isArray(openTalent?.projects)
    ? openTalent.projects
    : [];
  const cvFiles = parseMaybeArray(openTalent?.cv ?? profileData?.cv, []);
  const workSamplesCombined = [
    ...workSampleProjects
      .filter((item) => item?.project_url)
      .map((item) => ({
        url: item.project_url,
        name: item.project_url?.split("/").pop() || "Project",
      })),
    ...workSamples.map((item) => {
      if (typeof item === "string") {
        return {
          url: item,
          name: item.split("/").pop() || item,
        };
      }
      return item;
    }),
  ];

  const certificateFiles = parseMaybeArray(
    openTalent?.certificates ?? profileData?.certificates,
    []
  );
  const keySkillsSource =
    openTalent?.key_skills || openTalent?.skills || "";
  const keySkills =
    typeof keySkillsSource === "string"
      ? keySkillsSource.split(",").map((s) => s.trim()).filter(Boolean)
      : Array.isArray(keySkillsSource)
        ? keySkillsSource
        : [];

  const toolsUsedSource =
    openTalent?.tools || openTalent?.tools_software_used || "";
  const toolsUsed =
    typeof toolsUsedSource === "string"
      ? toolsUsedSource.split(",").map((s) => s.trim()).filter(Boolean)
      : Array.isArray(toolsUsedSource)
        ? toolsUsedSource
        : [];

  const preferredProjectTypes =
    typeof openTalent?.preferred_project_type === "string"
      ? openTalent.preferred_project_type.split(",").map((s) => s.trim()).filter(Boolean)
      : Array.isArray(openTalent?.preferred_project_type)
        ? openTalent.preferred_project_type
        : [];
  const companyDetails =
    openTalent?.company_details ||
    openTalent?.company_description ||
    openTalent?.company_bio ||
    "";

  const [projectSkills, setProjectSkills] = useState([]);

  if (subLoading) {
    return <Loader />
  }
  return (
    <FreelancerLayout>
      <div className="ct_px_40 my-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6 mb-4 mb-xl-0">
              <div>
                <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20">
                  <div className="d-flex align-items-start gap-3 ct_flex_col_575 ">
                    <div className="ct_profile_pic ct_flex_shrink_0">
                      <img
                        src={
                          profileData?.profile_image ||
                          openTalent?.profile_image ||
                          "/assets/img/user_profile.png"
                        }
                      />
                    </div>
                    <div className="ct_flex_1">
                      <div className="d-flex align-items-center gap-3 justify-content-between mb-3 ">
                        <div>
                          <h4 className="ct_fs_20 ct_darkblue_text mb-2">
                            {fullName || "N/A"}
                          </h4>
                          <p className="ct_fs_14 ct_darkblue_text mb-0">
                            <i class="fa-solid fa-location-dot"></i>{" "}
                            {locationText || "#N/A"}
                          </p>
                        </div>
                        <div>
                          <button
                            className="ct_yellow_btn ct_sky_blue_btn ct_h_32 ct_white_nowrap"
                            type="button"
                            onClick={() => navigate(findAJobPaths.EditProfile)}
                          >
                            Edit Profile
                          </button>
                        </div>
                      </div>
                      <div className="ct_grey_text">
                        <ReadMoreText text={profileData?.open_talent?.bio || ""} />
                      </div>
                      {companyDetails && (
                        <div className="ct_grey_text ct_mt_16">
                          <p className="ct_fs_14 ct_darkblue_text mb-1">
                            Company Details
                          </p>
                          <ReadMoreText text={companyDetails} />
                        </div>
                      )}
                      <ul>
                        <li className="d-flex align-items-center gap-2">
                          <img src="../assets/img/grey_mail_icon.svg" />
                          {profileData?.email || ""}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul className="d-flex align-items-center gap-4 flex-wrap ct_mt_40">
                    <li>
                      <div className="d-flex align-items-center gap-2">
                        <img src="../assets/img/tabler_clock.svg" />
                        <div>
                          <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                            {openTalent?.years_of_experience || "N/A"} Experience
                          </h4>
                          <p className="ct_fs_14 ct_grey_text mb-0">Experience</p>
                        </div>
                      </div>
                    </li>
                    {profileData?.open_talent?.certificates?.length > 0 && (
                      <li>
                        <div className="d-flex align-items-center gap-2">
                          <img src="../assets/img/hugeicons_award-01.svg" />
                          <div>
                            <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                              {profileData?.open_talent?.certificates?.length || ""} Certificate
                              {profileData?.open_talent?.certificates?.length > 1 ? "s" : ""}
                            </h4>
                            <p className="ct_fs_14 ct_grey_text mb-0">Advanced</p>
                          </div>
                        </div>
                      </li>
                    )}
                    <li>
                      <div className="d-flex align-items-center gap-2">
                        <img src="../assets/img/hugeicons_job-link.svg" />
                        <div>
                          <h4 className="ct_fs_16 mb-1 ct_darkblue_text">
                            {experiences.length} Experience
                            {experiences.length === 1 ? "" : "s"}
                          </h4>
                          <p className="ct_fs_14 ct_grey_text mb-0">Completed</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20 ct_mt_40">
                  <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                    <p className="ct_fs_16 mb-0 ct_darkblue_text">Personal Information</p>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Email Address</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{profileData?.email || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Phone Number</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">
                        {profileData?.phone_number || openTalent?.phone_number || "N/A"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Country of Residence</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.country || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">City</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.city || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">LinkedIn Profile</p>
                      <a className="ct_fs_14 ct_darkblue_text mb-0" href={openTalent?.linkedin_profile} target="_blank">
                        {openTalent?.linkedin_profile || "N/A"}
                      </a>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Portfolio</p>
                      <a className="ct_fs_14 ct_darkblue_text mb-0" href={openTalent?.website_or_portfolio} target="_blank">
                        {openTalent?.website_or_portfolio || "N/A"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ct_outline_bg h-auto ct_border_radius_10 ct_p_20 ct_mt_40">
                <div className="ct_mt_28">
                  <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                    <p className="ct_fs_16 mb-0 ct_darkblue_text">Professional Information</p>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Primary Role / Profession</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.primary_role || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Years of Experience</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.years_of_experience || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Availability</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.availability || "N/A"}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <p className="ct_fs_14 ct_grey_text mb-0">Hourly Rate (Optional)</p>
                      <p className="ct_fs_14 ct_darkblue_text mb-0">{openTalent?.hourly_rate || "N/A"}</p>
                    </div>
                  </div>
                </div>
                {preferredProjectTypes?.length > 0 && (
                  <div className="ct_mt_28">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                      <p className="ct_fs_16 mb-0 ct_darkblue_text">Preferred Project Type</p>
                    </div>
                    <ul className="d-flex align-items-center gap-3 flex-wrap cr_para_scroll ct_custom_scroll">
                      {preferredProjectTypes.map((item, index) => (
                        <li className="mb-2" key={`project-type-${index}`}>
                          <span className="ct_shadow_badge">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {toolsUsed?.length > 0 && (
                  <div className="ct_mt_28">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                      <p className="ct_fs_16 mb-0 ct_darkblue_text">Tools & Software Used</p>
                    </div>
                    <ul className="d-flex align-items-center gap-3 flex-wrap cr_para_scroll ct_custom_scroll">
                      {toolsUsed.map((item, index) => (
                        <li className="mb-2" key={`tool-${index}`}>
                          <span className="ct_shadow_badge">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {profileData?.open_talent?.skills?.split(",")?.length > 0 && (
                  <div className="ct_mt_28">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                      <p className="ct_fs_16 mb-0 ct_darkblue_text">Skills</p>
                    </div>
                    <ul className="d-flex align-items-center gap-3 flex-wrap cr_para_scroll ct_custom_scroll">
                      {profileData?.open_talent?.skills
                        ?.split(",")
                        ?.map((item, index) => (
                          <li className="mb-2">
                            <span className="ct_shadow_badge">{item}</span>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xl-6 mb-4 mb-xl-0">
              <div>
                <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <h5 className="mb-0 ct_fs_20 ct_darkblue_text">
                      Job Experience
                    </h5>
                  </div>
                  <ul className="ct_mt_30">
                    {experiences?.length > 0 ? (
                      experiences.map((exp, idx) => (
                        <li key={`experience-${idx}`}>
                          <div className="d-flex align-items-start gap-2  ct_flex_col_575 mb-2">
                            <div>
                              <div className="d-flex align-items-center gap-3 ct_flex_1 justify-content-between">
                                <div>
                                  <h5 className="ct_fs_16 mb-2">
                                    {exp?.job_title || "Job Title"}
                                  </h5>
                                  <p className="mb-0 ct_fs_16 ct_grey_text">
                                    {exp?.company_name || "Company Name"}
                                  </p>
                                </div>
                                <div className="d-flex align-items-center gap-5">
                                  <p className="d-flex align-items-center gap-2 ct_fs_12">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25C7.20979 2.25 5.4929 2.96116 4.22703 4.22703C2.96116 5.4929 2.25 7.20979 2.25 9Z"
                                        stroke="#535862"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M9 5.25V9L10.5 11.5"
                                        stroke="#535862"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    {exp?.start_date
                                      ? `${pipViewDate2(exp.start_date)} - ${exp?.currently_working
                                        ? "Present"
                                        : exp?.end_date
                                          ? pipViewDate2(exp.end_date)
                                          : "N/A"
                                      }`
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>
                              <p className="ct_para_scroll ct_custom_scroll ct_fs_15 mt-3 ct_darkblue_text" style={{ maxHeight: "150px" }}>
                                {exp?.job_description || "No description added yet."}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li>
                        <p className="ct_grey_text mb-0">No experiences added yet.</p>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_20">
                  <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_20">
                    <p className="ct_fs_16 mb-0 ct_darkblue_text">Work Samples</p>
                  </div>
                  {openTalent?.sample_portfolio_link
                    ?.split(",")
                    ?.map((link) => link.trim())
                    ?.filter(Boolean)?.length > 0 && (
                      <>
                        <p className="ct_fs_14 ct_darkblue_text mb-2">
                          Work Sample Links
                        </p>
                        <div className="ct_work_sample_list ct_mb_20">
                          {openTalent?.sample_portfolio_link
                            ?.split(",")
                            ?.map((link) => link.trim())
                            ?.filter(Boolean)
                            ?.map((link, index) => (
                              <div
                                key={`work-sample-link-${index}`}
                                className="ct_work_sample_item"
                              >
                                <span className="ct_badge_grey ct_work_sample_label">
                                  {link}
                                </span>
                                <a
                                  className="ct_outline_btn ct_h_32 ct_btn_inline"
                                  href={link}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  View
                                </a>
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                  <p className="ct_fs_14 ct_darkblue_text mb-2">Work Sample Files</p>
                  {workSamplesCombined.length > 0 ? (
                    <div className="ct_work_sample_list">
                      {workSamplesCombined.map((item, index) => {
                        const label =
                          item?.name ||
                          item?.project_url?.split("/").pop() ||
                          item?.url?.split("/").pop() ||
                          `Sample ${index + 1}`;
                        const link = item?.url || item?.project_url;
                        return (
                          <div
                            key={`${label}-${index}`}
                            className="ct_work_sample_item"
                          >
                            <span className="ct_badge_grey ct_work_sample_label">
                              {label}
                            </span>
                            {link && (
                              <a
                                className="ct_outline_btn ct_h_32 ct_btn_inline"
                                href={link}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View
                              </a>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="ct_grey_text mb-0">No work samples added yet.</p>
                  )}
                </div>
                {(cvFiles.length > 0 || certificateFiles.length > 0) && (
                  <div className="ct_outline_bg ct_border_radius_10 ct_p_20 ct_mt_20">
                    {cvFiles.length > 0 && (
                      <div className="mb-3">
                        <p className="ct_fs_14 ct_darkblue_text mb-1">CV</p>
                        <ul className="ct_para_scroll ct_custom_scroll ct_documents_lists mt-2">
                          {cvFiles.map((file, idx) => {
                            const link =
                              typeof file === "string"
                                ? file
                                : file?.url || file?.preview || "";
                            const label =
                              typeof file === "string"
                                ? file.split("/").pop()
                                : file?.name || `cv-${idx + 1}.pdf`;
                            return (
                              <li key={`cv-${idx}`}>
                                <p className="mb-0 d-flex align-items-center gap-2">
                                  <i class="fa-regular fa-file-pdf"></i>
                                  <span className="text-truncate ct_fs_14">
                                    {label}
                                  </span>
                                </p>
                                <p className="mb-0 ct_down_documents_icon">
                                  <a href={link} target="_blank">
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                  </a>
                                </p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                    {certificateFiles.length > 0 && (
                      <div>
                        <p className="ct_fs_14 ct_darkblue_text mb-1">
                          Certificates
                        </p>
                        <ul className="ct_para_scroll ct_custom_scroll ct_documents_lists mt-2">
                          {certificateFiles.map((file, idx) => {
                            const link =
                              typeof file === "string"
                                ? file
                                : file?.file || file?.url || file?.preview || "";
                            const label =
                              typeof file === "string"
                                ? file.split("/").pop()
                                : file?.name ||
                                file?.file?.split?.("/").pop?.() ||
                                `certificate-${idx + 1}`;
                            const isPdf =
                              typeof file === "string"
                                ? file.toLowerCase().includes(".pdf")
                                : (file?.type || "")
                                  .toLowerCase()
                                  .includes("pdf");
                            return (
                              <li key={`certificate-${idx}`}>
                                <p className="mb-0 d-flex align-items-center gap-2">
                                  <i
                                    class={
                                      isPdf
                                        ? "fa-regular fa-file-pdf"
                                        : "fa-regular fa-image"
                                    }
                                  ></i>
                                  <span className="text-truncate ct_fs_14">
                                    {label}
                                  </span>
                                </p>
                                <p className="mb-0 ct_down_documents_icon">
                                  <a href={link} target="_blank">
                                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                  </a>
                                </p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
                <div className="ct_outline_bg h-100 ct_border_radius_10 ct_p_20 ct_mt_20">
                  <div className="row">
                    <div className="col-md-10 mx-auto">
                      <div className="text-center p-3">
                        <svg
                          width="75"
                          height="75"
                          viewBox="0 0 75 75"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.5 2.08333C12.5 1.5308 12.7195 1.0009 13.1102 0.610195C13.5009 0.219494 14.0308 0 14.5833 0H60.4167C60.9692 0 61.4991 0.219494 61.8898 0.610195C62.2805 1.0009 62.5 1.5308 62.5 2.08333V4.16667H72.9167C73.4692 4.16667 73.9991 4.38616 74.3898 4.77686C74.7805 5.16756 75 5.69747 75 6.25V18.75C75 21.5127 73.9025 24.1622 71.949 26.1157C69.9955 28.0692 67.346 29.1667 64.5833 29.1667H61.0771C59.5874 33.3686 57.0029 37.0967 53.5907 39.9659C50.1784 42.835 46.062 44.7412 41.6667 45.4875V58.3333H54.1667C54.7192 58.3333 55.2491 58.5528 55.6398 58.9435C56.0305 59.3342 56.25 59.8641 56.25 60.4167V72.9167C56.25 73.4692 56.0305 73.9991 55.6398 74.3898C55.2491 74.7805 54.7192 75 54.1667 75H20.8333C20.2808 75 19.7509 74.7805 19.3602 74.3898C18.9695 73.9991 18.75 73.4692 18.75 72.9167V60.4167C18.75 59.8641 18.9695 59.3342 19.3602 58.9435C19.7509 58.5528 20.2808 58.3333 20.8333 58.3333H33.3333V45.4875C28.938 44.7412 24.8216 42.835 21.4093 39.9659C17.9971 37.0967 15.4126 33.3686 13.9229 29.1667H10.4167C7.65399 29.1667 5.00447 28.0692 3.05097 26.1157C1.09747 24.1622 0 21.5127 0 18.75V6.25C0 5.69747 0.219494 5.16756 0.610195 4.77686C1.0009 4.38616 1.5308 4.16667 2.08333 4.16667H12.5V2.08333ZM62.5 20.8333V8.33333H70.8333V18.75C70.8333 20.4076 70.1749 21.9973 69.0027 23.1694C67.8306 24.3415 66.2409 25 64.5833 25H62.5V20.8333ZM12.5 8.33333H4.16667V18.75C4.16667 20.4076 4.82515 21.9973 5.99725 23.1694C7.16935 24.3415 8.75906 25 10.4167 25H12.5V8.33333Z"
                            fill="#FFB703"
                          />
                        </svg>
                      </div>
                      <div>
                        <h4 className="ct_fs_28 ct_darkblue_text text-center mt-0 mb-3">
                          Upgrade to Pro{" "}
                        </h4>
                        <p className="ct_darkblue_text text-center">
                          Get more visibility, better opportunities and growth
                          support
                        </p>
                        <ul>
                          <li className="ct_fs_14 ct_darkblue_text d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#8ECAE6"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </svg>
                            NuGlow - Kickstart your journey with curated jobs
                            and profile visibility
                          </li>
                          <li className="ct_fs_14 ct_darkblue_text mt-2 d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#8ECAE6"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </svg>
                            NuForge - Grow faster with access to premium
                            listings and tools
                          </li>
                          <li className="ct_fs_14 ct_darkblue_text mt-2 d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#8ECAE6"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </svg>
                            NuStar - Stand out with early job invites, brand
                            support and pro-level exposure
                          </li>
                        </ul>
                        <div className="mt-4  text-center">
                          <button className="ct_yellow_btn mx-auto ct_sky_blue_btn ct_px_60">
                            Explore Plans
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      <div
        className="modal modal-lg ct_congratulation_modal_fade"
        id="ct_add_experience_modal"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="ct_fs_16 ct_darkblue_text mb-0">
                Add Experience
              </h4>
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_20 pt-0">
              <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Job Title
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder=" Job title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Company Name
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder=" Company name"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Duration
                      </label>
                      <input
                        type="date"
                        className="form-control ct_fs_12 ct_input"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Category
                      </label>
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_fs_12 ct_input">
                          <option>Project Category</option>
                          <option>Project Category</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Description
                      </label>
                      <textarea
                        className="form-control ct_input h-auto ct_fs_12"
                        rows={4}
                        placeholder="Briefly describe what you worked on, your responsibilities, and the outcome(max 400 characters)"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Upload Project Image (2 max)
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>

                        <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                          Upload your project image here
                        </p>
                        <label for="ct_upload_product">
                          <input
                            type="file"
                            name=""
                            id="ct_upload_product"
                            class="d-none"
                          />
                        </label>
                      </div>

                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          src="assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                          alt=""
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                  <button
                    className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                    style={{ borderColorL: "#53586252" }}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-lg ct_congratulation_modal_fade"
        id="ct_add_portfolio_modal"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="ct_fs_16 ct_darkblue_text mb-0">
                Add New Portfolio
              </h4>
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_20 pt-0">
              <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Title
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder=" Project title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Role in Project
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder=" Role in project"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Start Date
                      </label>
                      <input
                        type="date"
                        className="form-control ct_fs_12 ct_input"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Team Member
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder="Enter Team Member"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Budget
                      </label>
                      <input
                        type="text"
                        className="form-control ct_fs_12 ct_input"
                        placeholder="Enter Budget"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Duration
                      </label>
                      <div className="position-relative">
                        <input
                          type="number"
                          className="form-control ct_input"
                          style={{ paddingLeft: "80px" }}
                        />
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select
                            className="ct_input ct_fs_12 ct_day_select"
                            style={{ height: "auto" }}
                          >
                            <option value="month">Month</option>
                            <option value="day">Day</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <TagInput
                    label="Skills"
                    placeholder="Type to add skills..."
                    name="project_skills"
                    value={projectSkills}
                    onChange={(name, value) => setProjectSkills(value)}
                  />

                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Project Description
                      </label>
                      <textarea
                        className="form-control ct_input h-auto ct_fs_12"
                        rows={4}
                        placeholder="Tell a brief story: what was the goal, your contribution and the impact (max 500 characters)"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Upload Portfolio Image (2 max)
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                          Upload your Portfolio here
                        </p>
                        <label for="ct_upload_product">
                          <input
                            type="file"
                            name=""
                            id="ct_upload_product"
                            class="d-none"
                          />
                        </label>
                      </div>
                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          src="assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                          alt=""
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                  <button
                    className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                    style={{ borderColorL: "#53586252" }}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </FreelancerLayout >
  );
};

export default Profile;

